/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IAppServer } from "../app";
import { IServiceFactory } from "../services/IServiceFactory";
import { ISecretsProvider, ISecretsProviderOptions } from "./ISecretsProvider";

export function createSecretsProviderFactory<
	TOptions extends ISecretsProviderOptions,
	TClass extends ISecretsProvider
>(entity: new (config: TOptions, app: IAppServer) => TClass): IServiceFactory<TClass, TOptions> {
	return {
		factory: (config: TOptions, app: IAppServer) => new entity(config, app)
	};
}
